
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-chat/demos/team-messaging",
      function () {
        return require("private-next-pages/x/react-chat/demos/team-messaging.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-chat/demos/team-messaging"])
      });
    }
  